import { Swiper, Navigation, Pagination, Drift } from "@hh/global.js";

class ProductMedia extends HTMLElement {
    constructor() {
        super();

        Swiper.use([Navigation]);

        this.swiperSlider = new Swiper(this.querySelector(".js-slider"), {
            lazy: !0,
            navigation: {
                nextEl: this.querySelector(".js-next"),
                prevEl: this.querySelector(".js-prev"),
            },
            pagination: {
                el: this.querySelector(".swiper-pagination"),
                clickable: !0,
            },
        });

        this.swiperThumbnailSlider = new Swiper(
            this.querySelector(".js-thumbnail-slider"),
            {
                direction: "vertical",
                slidesPerView: 4,
                spaceBetween: 20,
                navigation: {
                    nextEl: this.querySelector(".js-thumbnail-next"),
                    prevEl: this.querySelector(".js-thumbnail-prev"),
                },
            }
        );

        this.swiperSlider.on("transitionEnd", () => {
            const index = this.swiperSlider.realIndex;

            this.onSliderChange(this.swiperSlider.realIndex);
            this.onSliderChange(index);

            this.swiperThumbnailSlider.slideTo(index);
        });

        this.mainImages = this.querySelectorAll(".js-media-main-item");
        this.thumbImages = this.querySelectorAll(".js-media-thumbnail-item");

        this.addEventListener(
            "SWATCH_IMAGES_CHANGE",
            this.onSwatchImagesChanged.bind(this)
        );

        this.thumbImages.forEach((e) => {
            e.addEventListener("click", () => {
                this.onThumbnailClicked(e);
            });
        });

        this.mainImages.forEach((e) => {
            e.classList.contains("js-video-item") ||
                (this.imageDrift = new Drift(e, {
                    paneContainer: this.querySelector(".js-media-item-zoom"),
                    hoverBoundingBox: !0,
                    boundingBoxContainer: this.querySelector(
                        ".js-media-item-zoom-box"
                    ),
                    zoomFactor: 3,
                    onShow: () => this.onZoomShow(),
                    onHide: () => this.onZoomHide(),
                }));
        });

        this.adjustZoomBox();

        window.addEventListener("resize", () => {
            this.adjustZoomBox();
        });

        if (this.activeThumbs.length > 4) {
            this.querySelector(".js-thumbnail-next").classList.remove("hidden");
            this.querySelector(".js-thumbnail-prev").classList.remove("hidden");
        } else {
            this.querySelector(".js-thumbnail-next").classList.add("hidden");
            this.querySelector(".js-thumbnail-prev").classList.add("hidden");
        }

        /*
         * TG START
         * Initialize the product media based on the variant
         * provided in the URL, e.g. ?variant=45385815916613
         */
        this.initializeVariantMedia();
        /* TG END */
    }

    onZoomHide() {
        this.querySelectorAll(
            ".js-media-item-zoom, .js-media-item-zoom-box"
        ).forEach((e) => e.classList.add("disabled"));
    }

    onZoomShow() {
        this.querySelectorAll(
            ".js-media-item-zoom, .js-media-item-zoom-box"
        ).forEach((e) => e.classList.remove("disabled"));
    }

    adjustZoomBox() {
        const e = this.querySelector(".js-media-item-zoom-box"),
            i = e.getBoundingClientRect();

        e.style.setProperty("--hh-margin-top", 0 - i.top + "px");
        e.style.setProperty("--hh-margin-left", 0 - i.left + "px");
    }

    /*
     * TG START
     * Select the correct product media when the page is opened
     * directly with a variant URL.
     *
     * Example:
     * /products/product-name?variant=45385815916613
     * TG END
     */
    initializeVariantMedia() {
        const variantId = new URLSearchParams(
            window.location.search
        ).get("variant");

        if (!variantId) return;

        const productJson = document.querySelector(".js-product-json");

        if (!productJson) {
            console.warn("Product JSON not found");
            return;
        }

        let productData;

        try {
            productData = JSON.parse(productJson.textContent);
        } catch (error) {
            console.error("Unable to parse product JSON:", error);
            return;
        }

        const variant = productData.variants?.find(
            (variant) => String(variant.id) === String(variantId)
        );

        if (!variant) {
            console.warn("Variant not found for URL:", variantId);
            return;
        }

        const mediaId = variant.featured_media?.id;

        if (!mediaId) {
            console.warn(
                "Featured media not found for variant:",
                variantId
            );
            return;
        }

        const mediaItems = Array.from(
            this.querySelectorAll(".js-media-main-item")
        );

        const position = mediaItems.findIndex((item) => {
            return String(item.dataset.mediaId) === String(mediaId);
        });

        if (position === -1) {
            console.warn("Media element not found:", mediaId);
            return;
        }

        this.swiperSlider.updateSlides();
        this.swiperThumbnailSlider.updateSlides();

        this.swiperSlider.slideTo(position);
        this.swiperThumbnailSlider.slideTo(position);

        this.onSliderChange(position);
    }

    onSwatchImagesChanged(e) {
        const handle = e.detail?.handle;

        if (!handle) return;

        const productJson = document.querySelector(".js-product-json");

        if (!productJson) {
            console.warn("Product JSON not found");
            return;
        }

        let productData;

        try {
            productData = JSON.parse(productJson.textContent);
        } catch (error) {
            console.error("Unable to parse product JSON:", error);
            return;
        }

        const variant = productData.variants?.find((variant) => {
            return this.handleize(variant.title) === handle;
        });

        if (!variant) {
            console.warn("Variant not found for handle:", handle);
            return;
        }

        const mediaId = variant.featured_media?.id;

        if (!mediaId) {
            console.warn(
                "Featured media not found for variant:",
                variant
            );
            return;
        }

        const mediaItems = Array.from(
            this.querySelectorAll(".js-media-main-item")
        );

        const position = mediaItems.findIndex((item) => {
            return String(item.dataset.mediaId) === String(mediaId);
        });

        if (position === -1) {
            console.warn("Media element not found:", mediaId);
            return;
        }

        this.swiperSlider.updateSlides();
        this.swiperThumbnailSlider.updateSlides();

        this.swiperSlider.slideTo(position);
        this.swiperThumbnailSlider.slideTo(position);

        this.onSliderChange(position);
    }

    handleize(value) {
        return String(value)
            .toLowerCase()
            .trim()
            .replace(/&/g, "-and-")
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
    }

    onThumbnailClicked(e) {
        const i = this.activeThumbs.indexOf(e);

        if (i > -1 && this.swiperSlider) {
            this.swiperSlider.slideTo(i);
        }
    }

    onSliderChange(e) {
        this.activeThumbs.forEach((i, t) => {
            t == e
                ? i.classList.add("active")
                : i.classList.remove("active");
        });
    }

    get activeThumbs() {
        return (
            Array.from(
                document.querySelectorAll(
                    ".js-media-thumbnail-item:not(.hidden)"
                )
            ) ?? []
        );
    }
}

customElements.define("hh-product-media", ProductMedia);